import { MARKETING_LIMITS } from '~/lib/constants/limits';

export function getMarketingCheckoutReturnUrl(
  value: unknown,
): string | undefined {
  if (
    typeof value !== 'string' ||
    !/^\/studio-checkout\?seats=\d+$/.test(value)
  )
    return;
  const seats = Number(value.split('=')[1]);
  if (
    !Number.isSafeInteger(seats) ||
    seats < MARKETING_LIMITS.MIN_STUDIO_SEATS ||
    seats > MARKETING_LIMITS.MAX_STUDIO_SEATS
  )
    return;
  return `/studio-checkout?seats=${seats}`;
}
